import React, { Component, } from 'react'
import { Alert, Form, FormGroup, Input, Label, Button, } from 'reactstrap'
import queryString from 'query-string'

import getRequest from '../../helpers/getRequest'
import { db } from '../../config/firebaseconfig'
import timestamper from '../../helpers/timestamper'

/*
  <ResetsForm
    isFetchingResetError={this.props.isFetchingResetError}
    reset={this.props.reset}
    saving={this.props.saving}
    savingSuccess={this.props.savingSuccess}
    savingError={this.props.savingError}
    isSaving={this.props.isSaving}
    isStudent={this.props.isStudent}
    isFetchingIsStudent={this.props.isFetchingIsStudent}
  />
*/

class ResetsForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      pass1: '',
      pass2: '',
      error: '',
      success: '',
    }
  }

  handleChange(e) {
    this.setState({[e.target.name]: e.target.value})
  }

  setPasswordSuccess() {
    // ****** Need to eventually log the person in here ******
    this.props.savingSuccess()
    this.setState({success: true, pass1: '', pass2: '', error: ''})
    let query = ''
    if (!this.props.isStudent) {
      query = `?gua=${this.props.reset.userId}`
    }
    this.props.history.replace(`/login`)
  }

  savePassword() {
    const p1 = this.state.pass1
    const p2 = this.state.pass2
    if (!p1) {
      this.setState({error: 'Password field must be completed.'})
      setTimeout(() => {
        this.setState({ error: false });
      }, 2000);
    } else if (p1 !== p2) {
      this.setState({error: 'Passwords do not match.'})
      setTimeout(() => {
        this.setState({ error: false });
      }, 2000);
    } else {
      const data = {
        id: this.props.reset.userId,
        password: p1,
      }
      const query = queryString.stringify(data)
      let url = `https://us-central1-bellwork-cg1.cloudfunctions.net/manualAddEducator?${query}`
      if (this.props.isStudent) {
        url = `https://us-central1-bellwork-cg1.cloudfunctions.net/manualAddStudent?${query}`
      }
      this.props.saving()
      getRequest(url)
        .then(() => {
          return db.collection('passwordResets').doc(this.props.reset.id).update({complete: true})
        })
        .then(() => this.setPasswordSuccess())
        .catch((err) => this.props.savingError(err))

    }
  }

  render() {
    let component = null
    if (this.props.reset) {
      const reset = this.props.reset

      const message = (
        <p className="reset-request-password-msg">
          {`Hello, ${reset.firstName}! Just one step left 
          to reset your password at MasteryPrep.com. 
          Create a new password below.`}
        </p>
      )

      let valid = ''
      if (this.state.error) {
        valid = 'is-invalid'
      }
      if (this.state.error && this.state.pass1 && this.state.pass1 === this.state.pass2) {
        valid = 'is-valid'
      }

      const form = (
        <Form className='reset-request-form-inputs'>
          <FormGroup>
            <Label htmlFor='pass1'>New Password</Label>
            <Input 
              type='password' 
              id='pass1' 
              name='pass1'  
              value={this.state.pass1}
              onChange={(e) => this.handleChange(e)}
              className={valid}
              disabled={this.state.success === true}
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor='pass2'>Confirm Password</Label>
            <Input
              type='password'
              id='pass2'
              name='pass2'
              value={this.state.pass2}
              onChange={(e) => this.handleChange(e)}
              className={valid}
              disabled={this.state.success === true}
            />
          </FormGroup>
        <div className='reset-request-password-button'>
          <Button
            color='primary'
            onClick={() => this.savePassword()}
            disabled={this.state.pass1 && !this.props.isFetchingIsStudent ? false : true}
            className={'mr-2'}
          >
            {this.props.isSaving || this.props.isFetchingIsStudent 
              ? <i className="fa fa-spinner fa-lg fa-spin"></i> 
              : 'Create New Password'}
          </Button>
          </div>
          <div className="reset-request-form-alerts" style={this.state.success || this.state.error ? {height: "47px"} : {height: "0px"}} >
          {this.state.error ? <Alert color='danger'>{this.state.error}</Alert> : ''}
          {this.state.success ? <Alert color='primary'>'Password reset complete! Taking you to the home page...'</Alert> : ''}
          </div>
        </Form>
      )
      const expired = reset.expirationDate < timestamper()
      component = (
        <div>
          {expired || reset.complete ? null : message}
          {expired || reset.complete ? null : form}
        </div>
      )
    }
 
    return (
      component
    )

  }
}

export default ResetsForm


// WEBPACK FOOTER //
// ./src/components/Users/ResetsForm.js